export default {
  SECTION_WIDGET_TAB: {
    container: {
      cellWidth: {
        100: {
          allow: true
        },
        66.66: {
          allow: false
        },
        58.33: {
          allow: false
        },
        50: {
          allow: true
        },
        41.67: {
          allow: false
        },
        33.33: {
          allow: false
        },
        25: {
          allow: false
        },
        20: {
          allow: false
        },
        16.66: {
          allow: false
        }
      }
    },
    fluid: {
      cellWidth: {
        100: {
          allow: true
        },
        66.66: {
          allow: false
        },
        58.33: {
          allow: false
        },
        50: {
          allow: true
        },
        41.67: {
          allow: false
        },
        33.33: {
          allow: false
        },
        25: {
          allow: false
        },
        20: {
          allow: false
        },
        16.66: {
          allow: false
        }
      }
    }
  }
}